<template>
  <v-popup @close="$emit('close')">
    <v-progress-bar :progress="progress" />
    <div class="pills-upload-status">
      <img class="pills-upload-status__img" src="~@/assets/upload-xls-image.svg" />
      <p class="pills-upload-status__text">{{ $t(title) }}</p>
    </div>
  </v-popup>
</template>

<script>
import { VPopup, VProgressBar } from "shared";
export default {
  name: "VPillsUploadStatusPopup",
  components: {
    VPopup,
    VProgressBar
  },
  props: {
    title: {
      type: String,
      default: null
    },
    progress: {
      type: Number,
      default: 0
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .popup {
  &__container {
    max-width: 470px;
    min-width: 0;
    width: 100%;
    padding: 0 0 100px 0;
  }
}
.pills-upload-status {
  text-align: center;
  &__img {
    margin: 110px 0 30px 0;
  }
  &__text {
    font-size: 16px;
    line-height: 17px;
    text-align: center;
    color: #333333;
    margin: 0 0 0 0;
  }
}
</style>
